module.exports = __webpack_public_path__ + "img/1 (127).4dbb11c2.png";